import React from "react";

import { useHistory } from "react-router-dom";
import Button from "components/Button";
import CupSvg from "assets/images/svg/cup.svg";
import "./index.scss";

const SubscriptionSuccess = () => {
  const history = useHistory();
  return (
    <div className="subscription-success">
      <img src={CupSvg} alt="Advanced" />
      <h1 className="title">You are now on advanced</h1>
      <p className="description">
        Exciting features awaits you! If you want to read more about advanced
        features, just click the bottom below.
      </p>
      <div className="action-group">
        <Button
          data-testid="exit-to-dashboard-button"
          icon="home"
          label="Exit to dashboard"
          type="outlined"
          color="white"
          prepend
          onClick={() => history.push("/dashboard")}
        />
        <Button
          data-testid="exit-to-dashboard-button"
          icon="home"
          label="Read more about advanced"
          type="outlined"
          color="white"
          prepend
          onClick={() => history.push("/advanced")}
        />
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
